import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/documentTemplateSources/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'

const defaultBoardState = {
  ids: [],
  isLoading: false,
  isLoaded: false
}

const initialState = {
  documentSourcesById: {},
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded
        }
      } : state
    case ADD:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ids: addUniqueValueToArray({
            array: state[action.payload.boardId].ids,
            value: action.payload.documentTemplateSourceId,
          }),
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ids: [ ...state[action.payload.boardId].ids ],
        }
      }

      action.payload.documentTemplateSourceIds.forEach(documentTemplateSourceId => {
        newState[action.payload.boardId].ids = addUniqueValueToArray({
          array: newState[action.payload.boardId].ids,
          value: documentTemplateSourceId,
        })
      })

      return newState
    }
    case REMOVE: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ids: [ ...state[action.payload.boardId].ids.filter(id => id !== action.payload.documentTemplateSourceId) ],
        }
      }

      return newState
    }
    default: return state
  }
}

export function setLoadStatus ({ boardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      isLoading,
      isLoaded
    }
  }
}

export function add ({ boardId, documentTemplateSourceId }) {
  return {
    type: ADD,
    payload: {
      boardId,
      documentTemplateSourceId
    }
  }
}

export function addArray ({ boardId, documentTemplateSourceIds }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      documentTemplateSourceIds
    }
  }
}

export function remove ({ boardId, documentTemplateSourceId }) {
  return {
    type: REMOVE,
    payload: {
      boardId,
      documentTemplateSourceId
    }
  }
}
